import { formatFileSize as formatBytes } from "@dhn/shared/utils/file-size";

export const formatFileSize = (size) => formatBytes(size, { empty: "0 KB" });

export const isImageDocument = (doc) => Boolean(doc?.type?.startsWith("image/"));

export const isPdfDocument = (doc) => doc?.type === "application/pdf";

export const getDocumentTypeLabel = (doc) =>
  isPdfDocument(doc) ? "PDF" : isImageDocument(doc) ? "Imagen" : "Archivo";

export const handleImagePreviewError = (event) => {
  event.currentTarget.hidden = true;
  const fallback = event.currentTarget.nextElementSibling;
  if (fallback) {
    fallback.hidden = false;
  }
};
